// @flow
import React, { Fragment } from "react";
import withStyles from "elevate-ui/withStyles";
import Accordion from "elevate-ui/Accordion";
import Typography from "elevate-ui/Typography";
import Calendar from "../common/icons/Calendar";
import classNames from "classnames";
import { withListingContext } from "./ListingContext";
import type { $OpenHouses, $OpenHouse } from "flow/types";

type $Props = {
  openHouses: $OpenHouses,
  classes: Object,
  openIndexes: number[],
};
type $OpenHouseProps = { openHouse: $OpenHouse, classes: Object };

const OpenHouses = ({ openHouses, classes, openIndexes }: $Props) => {
  if (!(openHouses && openHouses.length)) {
    return null;
  }
  const items = openHouses.map((openHouse) => ({
    title: openHouse.title,
    contents: <OpenHouseSection openHouse={openHouse} classes={classes} />,
  }));
  return (
    <div className={classes.root}>
      <Accordion
        classes={{
          button: classes.accordionButton,
          headerTitle: classes.title,
          content: classes.content,
        }}
        items={items}
        style={{ marginTop: "16px" }}
        openIndexes={openIndexes}
      />
    </div>
  );
};

const OpenHouseSection = ({ openHouse, classes }: $OpenHouseProps) => {
  return (
    <Fragment>
      <div className={classNames(classes.details, "ref__openHousePanel")}>
        <Typography type="body2" gutterTop gutterBottom>
          <div className={classes.topLine}>
            <div className={classes.date}>{openHouse.openHouseDescription}</div>
            <div className={classes.calendar}>
              <OpenHouseCalendars openHouse={openHouse} classes={classes} />
            </div>
          </div>
        </Typography>
        {openHouse.url &&
          openHouse.type === "virtual" && (
            <Typography
              type="body2"
              gutterTop
              gutterBottom
              className="ref__virtualLink"
            >
              Visit the Virtual Open House:{" "}
              <a href={openHouse.url} target="_blank" rel="noopener noreferrer">
                {openHouse.url}
              </a>
            </Typography>
          )}
        <Typography
          type="body2"
          gutterTop
          gutterBottom
          dangerouslySetInnerHTML={{
            __html: openHouse.description,
          }}
        />
      </div>
    </Fragment>
  );
};

const OpenHouseCalendars = ({ openHouse, classes }: $OpenHouseProps) => {
  return (
    <Fragment>
      {openHouse.calendars &&
        openHouse.calendars.map((calendar) => {
          return (
            <span className={classes.calendar} key={calendar.name}>
              <a href={calendar.url} target="_blank" rel="noopener noreferrer">
                <span className={classes.icon}>
                  <Calendar />
                </span>
                {calendar.name}
              </a>
            </span>
          );
        })}{" "}
    </Fragment>
  );
};
const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  title: {
    display: "flex",
    fontWeight: "600",
    fontSize: "15px",
    textTransform: "uppercase",
    color: theme.colors.gray["700"],
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  accordionButton: {
    display: "flex",
    padding: "12px 16px",
    textAlign: "left",
    alignItems: "center",
  },
  details: { padding: "10px 16px 10px 16px", backgroundColor: "#fafafa" },
  topLine: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
  },
  icon: {
    position: "relative",
    top: "8px",
    marginLeft: theme.spacing.unit,
  },
});

export default withStyles(styles)(withListingContext(OpenHouses));
